import { Asset } from "./Asset";
import { Engine } from "@spi/Engine/Engine";
import { ImageTexture } from "../Texture";

export class TextureAsset extends Asset {

    constructor(private id: string, private uri: string, public translucent: boolean) {
        super();
    }

    async resolveAsset(engine: Engine): Promise<void> {
        let texture = new ImageTexture({ source: this.uri });
        await texture.load(engine.ctx);
        texture.translucent = this.translucent;
        engine.materialManager.addTexture(this.id, texture);
    }
}
